// extracted by mini-css-extract-plugin
module.exports = {"pieChart":"_2Ya9f","path":"_1XUEH"};